import apiService from './apiService';

const userJetonService = {
  async list(userId) {
    const res = await apiService.makeRequest('GET', `/users/${userId}/jetons`);
    if (!res.success) {
      throw new Error(res.message || 'Impossible de charger les jetons');
    }
    return Array.isArray(res.data) ? res.data : [];
  },

  async create(userId, payload) {
    const res = await apiService.makeRequest('POST', `/users/${userId}/jetons`, payload);
    if (!res.success) {
      throw new Error(res.message || 'Impossible de générer le jeton');
    }
    return res;
  },

  async revoquer(userId, jetonId) {
    const res = await apiService.makeRequest('POST', `/users/${userId}/jetons/${jetonId}/revoquer`);
    if (!res.success) {
      throw new Error(res.message || 'Impossible de révoquer le jeton');
    }
    return res.data;
  },
};

export default userJetonService;
